import { css } from '@emotion/react'
import { Button, Cell, Grid, HFlow, Icon, Tooltip } from 'bold-ui'
import { Box } from 'components/Box'
import { Form, FormRenderProps, PecFormApi, SubmitButton } from 'components/form'
import { DateRangeField } from 'components/form/field/daterange/DateRangeField'
import { LotacoesComRegulacoesSelectField } from 'components/form/field/select/LotacoesComRegulacoesSelectField/LotacoesComRegulacoesSelectField'
import { useServerTime } from 'hooks/useServerTime'
import { metaPath } from 'util/metaPath'

import { ListaRegulacaoTableFilterPopperModel } from '../model-regulacao'

const path = metaPath<ListaRegulacaoTableFilterPopperModel>()

interface ListaRegulacaoFilterPopperFormProps {
  initialValues: ListaRegulacaoTableFilterPopperModel
  isFilterDefault: boolean
  onClose(): void
  onSubmit(
    values: ListaRegulacaoTableFilterPopperModel,
    formApi: PecFormApi<ListaRegulacaoTableFilterPopperModel>
  ): void
  onClear(): void
}

export function ListaRegulacaoFilterPopperForm(props: Readonly<ListaRegulacaoFilterPopperFormProps>) {
  const { initialValues, isFilterDefault, onSubmit, onClear, onClose } = props

  const { getServerTimeNow } = useServerTime()
  const now = getServerTimeNow()

  const renderForm = (formProps: FormRenderProps<ListaRegulacaoTableFilterPopperModel>) => {
    return (
      <Box style={styles.box}>
        <Grid>
          <Cell size={12}>
            <DateRangeField name={path.periodo} label='Período da solicitação' maxDate={now} />
          </Cell>
          <Cell size={12}>
            <LotacoesComRegulacoesSelectField name={path.solicitantes} label='Solicitante' multiple />
          </Cell>
          <Cell size={12}>
            <HFlow justifyContent='flex-end'>
              <Button onClick={onClose} size='small' skin='outline' kind='normal'>
                Fechar
              </Button>
              <Tooltip text='Redefinir filtros para o padrão'>
                <Button kind='normal' size='small' onClick={onClear} disabled={isFilterDefault}>
                  <Icon style={styles.iconRedo} icon='redo' />
                  Voltar para padrão
                </Button>
              </Tooltip>
              <SubmitButton size='small' handleSubmit={formProps.handleSubmit}>
                Filtrar
              </SubmitButton>
            </HFlow>
          </Cell>
        </Grid>
      </Box>
    )
  }

  return (
    <Form<ListaRegulacaoTableFilterPopperModel>
      render={renderForm}
      onSubmit={onSubmit}
      initialValues={initialValues}
      onSubmitSucceeded={onClose}
    />
  )
}

const styles = {
  box: css`
    width: 25rem;
    margin: 1rem 0;
  `,
  iconRedo: css`
    padding-right: 0.5rem;
  `,
}
